exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nhtml{overflow-y:auto\n}", "", {"version":3,"sources":["D:/DevelopSource/v2Nurse/vue/src/D:/DevelopSource/v2Nurse/vue/src/App.vue"],"names":[],"mappings":";AAsBA,KACI,eAAA;CAAA","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nhtml {\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = OCj8
// module chunks = 281